import {ErrorHandler, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {catchError, Observable, tap, throwError} from "rxjs";
import {CategoryDto} from "../../shared/models/category-dto";
import {WaiterShift} from "../../shared/models/waiter-shift";
import {Item} from "../../shared/models/item";
import {Category} from "../../shared/models/category";
import {Tenant} from "../../shared/models/tenant";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  private baseUrlItemsService = environment.apiUrl;
  private baseUrlItems = this.baseUrlItemsService + 'items';

  constructor(private http: HttpClient, private errorHandler: ErrorHandler, private _snackBar: MatSnackBar) { }

  getAllAvailableCategoriesAndItems(): Observable<CategoryDto[]> {
    return this.http.get<CategoryDto[]>(`${this.baseUrlItems}`).pipe(
      tap(_ => this.log('fetch categories and items')),
      catchError(this.handleError<CategoryDto[]>('get all available categories and items', []))
    );
  }

  getAllCategoriesAndItems(): Observable<CategoryDto[]> {
    return this.http.get<CategoryDto[]>(`${this.baseUrlItems}/all`).pipe(
      tap(_ => this.log('fetch categories and items')),
      catchError(this.handleError<CategoryDto[]>('get all categories and items', []))
    );
  }

  updateItem(item: Item): Observable<any> {
    return this.http.put<any>(`${this.baseUrlItems}`, item).pipe(
      tap(_ => this.log('put change item')),
      catchError(this.handleError<CategoryDto[]>('change item', []))
    );
  }

  createItem(item: Item): Observable<any> {
    return this.http.post<any>(`${this.baseUrlItems}`, item).pipe(
      tap(_ => this.log('put create item')),
      catchError(this.handleError<CategoryDto[]>('create item', []))
    );
  }

  deleteItem(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlItems}/${guid}`).pipe(
      tap(_ => this.log('delete item')),
      catchError(this.handleError<Category[]>('delete item', []))
    );
  }

  getAllTenantCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.baseUrlItems}/categories`).pipe(
      tap(_ => this.log('fetch categories')),
      catchError(this.handleError<Category[]>('get all categories and items', []))
    );
  }

  updateCategory(category: Category): Observable<any> {
    return this.http.put<any>(`${this.baseUrlItems}/categories`, category).pipe(
      tap(_ => this.log('put change category')),
      catchError(this.handleError<CategoryDto[]>('change category', []))
    );
  }

  createCategory(category: Category): Observable<any> {
    return this.http.post<any>(`${this.baseUrlItems}/categories`, category).pipe(
      tap(_ => this.log('put create category')),
      catchError(this.handleError<Category[]>('create category', []))
    );
  }

  deleteCategory(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlItems}/categories/${guid}`).pipe(
      tap(_ => this.log('delete category')),
      catchError(this.handleError<Category[]>('delete category', []))
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      this.errorHandler.handleError(error);

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      this._snackBar.open('Es ist ein Fehler aufgetreten.', 'Schließen', {duration: 3000});

      // Let the app keep running by returning an empty result.
      return throwError(() => error); //of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`OrderService: ${message}`);
  }


}
